/**
 * triggerInterpolator — pure function for `{{path.to.var}}` substitution
 * inside template titles at trigger-disparo time (REQUIREMENTS §7.3).
 *
 * Engine rules (intentionally minimal — REQUIREMENTS §3 Non-Goals NG4):
 *   - Replaces `{{path.to.var}}` with nested property lookup on vars.
 *   - Variable missing or nullish → empty string (silent fallback, REQUIREMENTS §7.2).
 *   - Empty / null / undefined template → return as-is (preserves caller intent).
 *   - No escapes, no format filters, no loops/conditionals.
 */

const VARIABLE_PATTERN = /\{\{([^}]+)\}\}/g

export function interpolate(template, vars) {
  if (template == null) return template
  if (typeof template !== 'string') return template
  return template.replaceAll(VARIABLE_PATTERN, function (_, path) {
    const value = String(path).trim().split('.').reduce(
      (o, k) => (o == null ? undefined : o[k]),
      vars || {}
    )
    if (value == null) return ''
    return String(value)
  })
}

export default { interpolate }
